import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service'
import { CreatePersonalAccessTokenResult, PersonalAccessToken } from '../models/personal-access-token';

@Injectable({
    providedIn: 'root'
})
export class UserPATService {

    constructor(private httpService: JsonHttpService) { }

    getTokensForUser(userId: number): Promise<PersonalAccessToken[]> {
        const options = { params: new HttpParams().set('userId', `${userId}`) };
        return this.httpService.get('/api/personal-access-tokens/get-tokens-for-user', options).toPromise();
    }

    createToken(token: PersonalAccessToken): Promise<CreatePersonalAccessTokenResult> {
        return this.httpService.post('/api/personal-access-tokens/create-token', token).toPromise();
    }

    updateToken(token: PersonalAccessToken): Promise<PersonalAccessToken> {
        return this.httpService.post('/api/personal-access-tokens/update-token', token).toPromise();
    }

    deleteToken(personalAccessTokenId: number) {
        const options = { params: new HttpParams().set('personalAccessTokenId', `${personalAccessTokenId}`) };
        return this.httpService.post('/api/personal-access-tokens/delete-token', null, options).toPromise();
    }
}
